import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import IBackupRestoreSetting from "../../models/settings/BackupRestoreSettings";
import {
  Input,
  Button,
  ToggleSwitch,
  Dropdown,
  DropdownOption,
} from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import { ABB_VIEW, ABB_HIDE } from "../../utilities/IconConstants";
import { tree } from "d3-hierarchy";

interface IProps {
  settings: any[];
  setIsNetworkShared: (value: boolean) => void;
  setDomain: (value: string) => void;
  setUserName: (value: string) => void;
  setPassword: (value: string) => void;
  setDrive: (value: string) => void;
  setLocation: (value: string) => void;
  testBackupFolderConnection: () => void;
}
interface AppState {
  isRevelPassword: boolean;
}

export default class BackupRestoreSettingLanding extends React.Component<
  IProps,
  AppState
> {
  private _mount: boolean = false;
  private _settingsData: any;
  private fileRef: any = React.createRef<HTMLDivElement>();
  private locationRef: any = React.createRef<HTMLDivElement>();
  private drives: any[] = [
    { value: "Z", label: "Z:" },
    { value: "Y", label: "Y:" },
    { value: "X", label: "X:" },
    { value: "W", label: "W:" },
    { value: "V", label: "V:" },
    { value: "U", label: "U:" },
    { value: "T", label: "T:" },
    { value: "S", label: "S:" },
    { value: "R", label: "R:" },
    { value: "Q", label: "Q:" },
    { value: "P", label: "P:" },
    { value: "O", label: "O:" },
    { value: "N", label: "N:" },
    { value: "M", label: "M:" },
    { value: "L", label: "L:" },
    { value: "K", label: "K:" },
    { value: "J", label: "J:" },
    { value: "I", label: "I:" },
    { value: "H", label: "H:" },
    { value: "G", label: "G:" },
    { value: "F", label: "F:" },
    { value: "E", label: "E:" },
    { value: "D", label: "D:" },
    { value: "B", label: "B:" },
    { value: "A", label: "A:" },
  ];

  constructor(props: IProps) {
    super(props);
    this._mount = true;
    this.state = {
      isRevelPassword: false,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    if (this.locationRef.current !== null) {
      this.locationRef.current.setAttribute("directory", "");
      this.locationRef.current.setAttribute("webkitdirectory", "");
    }
  }

  private togglePassword = () => {
    this.setState({
      isRevelPassword: !this.state.isRevelPassword,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            <div className="summary-layout mt-4">
              <div className="col-12">
                {this.props.settings &&
                  this.props.settings.map(
                    (data: any, index: number) => {
                      return (
                        <div key={index}>
                          <div className="row">
                            <label
                              className="col-3"
                              style={{ marginRight: "10px" }}
                            >
                              {t(CONSTANTS.LABEL_IS_NETWORK_SHARED)}
                            </label>
                            <ToggleSwitch
                              monochrome={true}
                              showIcons={true}
                              className="spinner-position"
                              value={data.isNetworkShared}
                              onChange={(value) =>
                                this.props.setIsNetworkShared(value)
                              }
                            />
                          </div>

                          {data.isNetworkShared ? (
                            <div>
                              <div className="row mt-3">
                                <label className="col-3">
                                  {t(CONSTANTS.LABEL_DOMAIN)}
                                </label>
                                <Input
                                  dataType="text"
                                  className="col-4"
                                  value={
                                    data.credentials !== null
                                      ? data.credentials.domain
                                      : ""
                                  }
                                  onValueChange={(value) =>
                                    this.props.setDomain(value)
                                  }
                                />
                              </div>

                              <div className="row mt-3">
                                <label className="col-3">
                                  {t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                                  <span className="required">*</span>
                                </label>
                                <Input
                                  dataType="text"
                                  className="col-4"
                                  required={true}
                                  value={
                                    data.credentials !== null
                                      ? data.credentials.userName
                                      : ""
                                  }
                                  onValueChange={(value) =>
                                    this.props.setUserName(value)
                                  }
                                />
                              </div>

                              <div className="row mt-3">
                                <label className="col-3">
                                  {t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                                  <span className="required">*</span>
                                </label>
                                <Input
                                  dataType={
                                    this.state.isRevelPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="col-4"
                                  required={true}
                                  value={
                                    data.credentials !== null
                                      ? data.credentials.password
                                      : ""
                                  }
                                  onValueChange={(value) =>
                                    this.props.setPassword(value)
                                  }
                                  icon={
                                    this.state.isRevelPassword
                                      ? ABB_VIEW
                                      : ABB_HIDE
                                  }
                                  onIconClick={this.togglePassword}
                                />
                              </div>

                              <div className="row mt-3">
                                <label className="col-3">
                                  {t(CONSTANTS.LABEL_DRIVE)}
                                  <span className="required">*</span>
                                </label>
                                <Dropdown
                                  allowAdd={false}
                                  className="col-4"
                                  searchable={true}
                                  placeholder={
                                    t(CONSTANTS.LABEL_PICK) +
                                    " " +
                                    t(CONSTANTS.LABEL_DRIVE)
                                  }
                                  value={[
                                    {
                                      value: data.drive,
                                      label: data.drive + ":",
                                    },
                                  ]}
                                  onChange={(v: any) =>
                                    this.props.setDrive(v[0].value)
                                  }
                                >
                                  {this.drives.map((o: any) => {
                                    return (
                                      <DropdownOption
                                        key={o.value}
                                        label={o.label}
                                        value={o.value}
                                      />
                                    );
                                  })}
                                </Dropdown>
                              </div>
                            </div>
                          ) : null}

                          <div className="row mt-3">
                            <label className="col-3">
                              {t(CONSTANTS.LABEL_LOCATION)}
                              <span className="required">*</span>
                            </label>
                            <Input
                              className="col-4"
                              dataType="text"
                              placeholder={
                                data.isNetworkShared
                                  ? t(CONSTANTS.SELECT_XML_PLACEHOLDER)
                                  : t("c:\\folder")
                              }
                              value={data.location}
                              onValueChange={(value) =>
                                this.props.setLocation(value)
                              }
                              required={true}
                            />
                          </div>
                          <div className="row mt-3">
                            <label className="col-3">{""}</label>
                            <Button
                              type="primary-black"
                              shape="pill"
                              className="spinner-position "
                              text={t(CONSTANTS.BUTTON_TEST)}
                              style={{ width: "100px", marginLeft: "15px" }}
                              onClick={() =>
                                this.props.testBackupFolderConnection()
                              }
                              isLoading={this.props.settings[0].isTestLoading}
                            />
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
